import React, { useEffect } from 'react';
import Modal from '../Modal';
import ReactDOM from 'react-dom';
import { useIsMobile } from '../../hooks/useIsMobile';

interface StripeStepProps {
  onCancel: () => void;
  onReady?: () => void;
  isLoading?: boolean;
  errorMessage?: string;
  frameId?: string;
  containerRef?: React.RefObject<HTMLDivElement>;
  isModalOpen?: boolean;
  onModalClose?: () => void;
}

const StripeStep: React.FC<StripeStepProps> = ({
  onCancel,
  onReady,
  isLoading,
  errorMessage,
  frameId = 'checkout-container',
  containerRef,
  isModalOpen = false,
  onModalClose,
}) => {
  const isMobile = useIsMobile();
  
  useEffect(() => {
    onReady?.();
  }, [onReady]);

  const modalContent = (
    <Modal
        open={isModalOpen}
        onClose={onModalClose}
        minWidth={isMobile ? undefined : "420px"}
      >
      <div className="w-full max-w-4xl mx-auto">
        <div 
          id={frameId}
          ref={containerRef}
          className={`checkout-container w-full ${isMobile ? '' : 'min-w-[420px]'} min-h-[520px] bg-white rounded-lg shadow-inner`}
          style={{ minHeight: '450px' }}
        ></div>
      </div>
    </Modal>
  );

  return (
    <div className="px-6 py-8 space-y-6">
      <div className="flex items-start justify-between">
        <div>
          <h2 className="text-xl font-semibold text-white">Upgrade plan</h2>
          <p className="text-sm text-white/70">
            Upgrade your plan to continue with the publishing process.
          </p>
        </div>
        <button
          onClick={onCancel}
          className="px-4 py-2 rounded-lg border border-white/20 text-white/80 text-sm hover:bg-white/5 transition-all duration-200"
        >
          Cancelar
        </button>
        { typeof ReactDOM.createPortal === 'function' ? 
          ReactDOM.createPortal(modalContent, document.body) : 
          modalContent
        }
        <div
          id={frameId}
          ref={containerRef}
          className={`min-h-[520px] bg-white rounded-lg shadow-inner ${isMobile ? 'w-full' : ''}`}
        />
      </div>

      {errorMessage && (
        <div className="rounded bg-error-red/10 border border-error-red/40 text-error-red text-sm px-4 py-3">
          {errorMessage}
        </div>
      )}

      {isLoading && !errorMessage && (
        <div className="text-white/70 text-sm">Carregando checkout…</div>
      )}

    </div>
  );
};

export default StripeStep;